import Dexie from 'dexie';

export const db = new Dexie('TrafficSummary');
db.version(2).stores({
  traffic: '++id, utmSource, utmMedium, utmCampaign, utmTerm, utmContent, referrerUrl, total',
});
